import { GetStaticProps } from "next";
import { useRouter } from "next/router";
import RecipeKioskLayout from "@Components/layout/RecipeKioskLayout";
import { BackToRecipesButton } from "@Components/recipes-detail/BackToRecipesButton";
import { RecipesDetailLayout } from "@Components/recipes-detail/RecipesDetailLayout";
import { KIOSK_VIEW_MODE_QUERY } from "@Constants/url";
import CmsPage, { getCMSPageModel } from "@Libs/contentful/components/CmsPage";
import { RESOURCE_NAMES } from "@Libs/contentful/constants";
import { queryRecipesDetailsPaths } from "@Libs/contentful/queries/ProductRecipeQuery";
import productRecipeQuery from "@Libs/contentful/queries/ProductRecipeQuery";
import { makeStaticProps } from "@Libs/i18n/getStatic";
import { IRecipesDetailPageContent } from "@Types/recipes-detail-page";
import logger from "@Utils/Logger";
import { getStaticPathsFromSlug } from "@Utils/contentful";

interface RecipesDetailPageProps extends IRecipesDetailPageContent {
  pageModel: any;
}

const RecipesDetailPage = ({ pageModel }: RecipesDetailPageProps) => {
  const {
    query: { viewMode },
  } = useRouter();
  const { pageContent = {} } = pageModel;

  // The kiosk in the O2O store view mode
  if (viewMode === KIOSK_VIEW_MODE_QUERY) {
    return (
      <RecipeKioskLayout
        pageModel={pageModel}
        pageTitle={pageContent.pageTitle}
        pageDescription={pageContent.pageDescription}
        rightHeaderContent={<BackToRecipesButton />}
      >
        <RecipesDetailLayout {...pageContent} />
      </RecipeKioskLayout>
    );
  }

  return (
    <CmsPage
      pageModel={pageModel}
      pageTitle={pageContent.pageTitle}
      pageDescription={pageContent.description}
    >
      <RecipesDetailLayout {...pageContent} />
    </CmsPage>
  );
};

export async function getStaticPaths() {
  try {
    const paths = await getStaticPathsFromSlug(queryRecipesDetailsPaths);

    return {
      paths,
      fallback: false,
    };
  } catch (error) {
    logger.error("recipes/[slug] getStaticPaths()", error);
  }
}

const overrideStaticProps: GetStaticProps = async (props) => {
  const { locale, slug } = props as { locale: string; slug: string };

  const pageModel = await getCMSPageModel(
    productRecipeQuery,
    {
      locale,
      slug,
      resourceName: RESOURCE_NAMES.recipesDetailPage,
    },
    {
      keepOriginalSlug: true,
    }
  );

  return {
    props: {
      pageModel,
    },
  };
};

const getStaticProps = makeStaticProps(["common"], overrideStaticProps);
export { getStaticProps };

export default RecipesDetailPage;
